import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { DineInLineItemStatusEnumStr, DineInLineItemStatusEnum } from 'enums'
import { OrderLineItemType } from 'hooks/useGlobalCart'
import LineItem, { ProductCartItem, StatusCartItem } from 'components/dine-in/LineItem'
import { useTranslation } from 'react-i18next'
import useLanguage from 'hooks/useLanguage'
interface GlobalCartItemListProps {
  lineItems: OrderLineItemType[]
  buffetPackageName?: string
}

const GlobalCartItemList: FC<GlobalCartItemListProps> = ({ lineItems, buffetPackageName = '' }) => {
  const { t } = useTranslation()
  const { getPropertyByLang } = useLanguage()

  const products: ProductCartItem[] = useMemo(() => {
    const getStatusCartItem = (lineItemStatus: DineInLineItemStatusEnumStr): StatusCartItem => {
      switch (lineItemStatus) {
        case DineInLineItemStatusEnum.Cooking:
          return {
            label: t('dineInCooking'),
            backgroundColor: '#2E8CE2',
          }
        case DineInLineItemStatusEnum.Serving:
          return {
            label: t('dineInServing'),
            backgroundColor: '#002C6B',
          }
        default:
          return {
            label: t('dineInServed'),
            backgroundColor: '#0EB639',
          }
      }
    }

    return lineItems.map((lineItem) => {
      const modifiers = lineItem.modifiers.map(
        ({
          modifier: {
            nameTh,
            nameEn,
            priceSatangs,
            modifierGroup: { multipleQuantity },
          },
          quantity,
        }) => ({
          name: getPropertyByLang({ en: nameEn, th: nameTh }),
          priceSatangs: priceSatangs,
          quantity,
          multipleQuantity: multipleQuantity,
        })
      )
      const {
        product: { nameEn, nameTh, excludedFromPromotion, images },
        status,
        totalSatangs,
        quantity,
      } = lineItem
      const name = getPropertyByLang({ en: nameEn, th: nameTh })
      const lineItemStatus = getStatusCartItem(status)
      return {
        images,
        name,
        status: lineItemStatus,
        modifiers,
        totalPriceSatangs: totalSatangs,
        quantity: quantity,
        excludedFromPromotion,
        buffetPackageName: lineItem?.buffetPackageID ? buffetPackageName : '',
        customNotes: lineItem.customNotes,
      }
    })
  }, [lineItems, buffetPackageName, getPropertyByLang, t])

  return (
    <Wrapper>
      {products.map((product, index) => (
        <LineItem key={index} product={product} />
      ))}
    </Wrapper>
  )
}

export default GlobalCartItemList

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 14px;
`
